import React from "react";

import Banner from "./Banner";
import Card from "./Card";
import "./Home.css";

function Home() {
  return (
    <div className="home">
      <Banner />
      <div className="home__section">
        <Card
          src="https://thumbcdn-4.hotelurbano.net/zXGaF1XHJV4Jy4T4xd3ziTTG4II=/trim:bottom-right:80/fit-in/625x0/bottom/filters:quality(30)/https%3A//novo-hu.s3.amazonaws.com/reservas/ota/prod/hotel/524959/guest-house--experiences-001_20200518171319.jpg"
          title="Entire homes"
          description="Comfortable private places, with room for friends or family"
        />
        <Card
          src="https://thumbcdn-4.hotelurbano.net/zXGaF1XHJV4Jy4T4xd3ziTTG4II=/trim:bottom-right:80/fit-in/625x0/bottom/filters:quality(30)/https%3A//novo-hu.s3.amazonaws.com/reservas/ota/prod/hotel/524959/guest-house--experiences-001_20200518171319.jpg"
          title="Entire homes"
          description="Comfortable private places, with room for friends or family"
        />
        <Card
          src="https://thumbcdn-4.hotelurbano.net/zXGaF1XHJV4Jy4T4xd3ziTTG4II=/trim:bottom-right:80/fit-in/625x0/bottom/filters:quality(30)/https%3A//novo-hu.s3.amazonaws.com/reservas/ota/prod/hotel/524959/guest-house--experiences-001_20200518171319.jpg"
          title="Entire homes"
          description="Comfortable private places, with room for friends or family"
        />
      </div>
      <div className="home__section">
        <Card
          src="https://thumbcdn-4.hotelurbano.net/zXGaF1XHJV4Jy4T4xd3ziTTG4II=/trim:bottom-right:80/fit-in/625x0/bottom/filters:quality(30)/https%3A//novo-hu.s3.amazonaws.com/reservas/ota/prod/hotel/524959/guest-house--experiences-001_20200518171319.jpg"
          title="Entire homes"
          description="Comfortable private places, with room for friends or family"
          price="40"
        />
        <Card
          src="https://thumbcdn-4.hotelurbano.net/zXGaF1XHJV4Jy4T4xd3ziTTG4II=/trim:bottom-right:80/fit-in/625x0/bottom/filters:quality(30)/https%3A//novo-hu.s3.amazonaws.com/reservas/ota/prod/hotel/524959/guest-house--experiences-001_20200518171319.jpg"
          title="Entire homes"
          description="Comfortable private places, with room for friends or family"
          price="40"
        />
        <Card
          src="https://thumbcdn-4.hotelurbano.net/zXGaF1XHJV4Jy4T4xd3ziTTG4II=/trim:bottom-right:80/fit-in/625x0/bottom/filters:quality(30)/https%3A//novo-hu.s3.amazonaws.com/reservas/ota/prod/hotel/524959/guest-house--experiences-001_20200518171319.jpg"
          title="Entire homes"
          description="Comfortable private places, with room for friends or family"
          price="40"
        />
      </div>
    </div>
  );
}

export default Home;
